import React from "react";
import {Button} from "react-bootstrap";
import {ArrowLeftRounded} from "./Icons";

const LpNewPrevArrow = (props) => {
    const {customClass, stroke, customStyle, onClick} = props;
    return (
        <Button
            onClick={onClick}
            variant="clean"
            className={customClass}
            aria-label="Previous"
            disabled={!onClick}
        >
            <ArrowLeftRounded
                className="carousel-arrow"
                stroke={stroke}
                style={customStyle}
            />
        </Button>
    );
}

export default LpNewPrevArrow;